// import { Grid, NativeSelect, Stack } from "@mantine/core";
// import { notifications } from "@mantine/notifications";
// import React, { useState } from "react";
// import persian from "react-date-object/calendars/persian";
// import persian_fa from "react-date-object/locales/persian_fa";
// import { DateObject } from "react-multi-date-picker";
import { Group, NativeSelect } from "@mantine/core";
import React, { useEffect, useState } from "react";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
import { DateObject } from "react-multi-date-picker";

// interface DateSelectorProps {
//   selectedDate: DateObject;
//   onChange: (newDate: DateObject) => void;
// }

// export const DateSelector: React.FC<DateSelectorProps> = ({
//   selectedDate,
//   onChange,
// }) => {
//   const today = new DateObject({ calendar: persian, locale: persian_fa });

//   const [date, setDate] = useState<DateObject>(
//     new DateObject({ ...selectedDate, calendar: persian, locale: persian_fa })
//   );

//   const isBeforeToday = (date: DateObject): boolean => {
//     return (
//       date.year < today.year ||
//       (date.year === today.year &&
//         (date.month.index < today.month.index ||
//           (date.month.index === today.month.index && date.day < today.day)))
//     );
//   };

//   const isLeapYear = (year: number): boolean => {
//     return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
//   };

//   const getDaysInMonth = (date: DateObject): number => {
//     const daysInMonth: Record<number, number> = {
//       1: 31,
//       2: 31,
//       3: 31,
//       4: 31,
//       5: 31,
//       6: 31,
//       7: 30,
//       8: 30,
//       9: 30,
//       10: 30,
//       11: 30,
//       12: isLeapYear(date.year) ? 30 : 29,
//     };
//     return daysInMonth[date?.month?.index + 1] || 29;
//   };

//   const days = Array.from({ length: getDaysInMonth(date) }, (_, i) => i + 1);
//   const months = date.locale.months.map((x) => x[0]);
//   const years = Array.from({ length: 3 }, (_, i) => today.year + i);

//   const handleDayChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
//     const day = parseInt(e.target.value, 10);
//     const newDate = new DateObject(date);
//     newDate["day"] = day;

//     if (!isBeforeToday(newDate)) {
//       setDate(newDate);
//       onChange(newDate);
//     } else {
//       notifications.show({
//         message: "تاریخ انتخابی باید از امروز بزرگتر باشد",
//         color: "yellow",
//       });
//     }
//   };

//   const handleMonthChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
//     const newDate = new DateObject(date);
//     const newMonthIndex = months.findIndex((m) => m === e.target.value) + 1;
//     newDate.setMonth(newMonthIndex);

//     if (!isBeforeToday(newDate)) {
//       setDate(newDate);
//       onChange(newDate);
//     } else {
//       notifications.show({
//         message: "تاریخ انتخابی باید از امروز بزرگتر باشد",
//         color: "yellow",
//       });
//     }
//   };

//   const handleYearChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
//     const year = parseInt(e.target.value, 10);
//     const newDate = new DateObject(date);
//     newDate["year"] = year;

//     if (!isBeforeToday(newDate)) {
//       setDate(newDate);
//       onChange(newDate);
//     } else {
//       notifications.show({
//         message: "تاریخ انتخابی باید از امروز بزرگتر باشد",
//         color: "yellow",
//       });
//     }
//   };

//   return (
//     <Stack>
//       <Grid>
//         <Grid.Col span={4}>
//           <NativeSelect
//             label="روز"
//             value={date.day}
//             onChange={handleDayChange}
//             size="md"
//           >
//             {days.map((day) => (
//               <option key={day} value={day}>
//                 {day}
//               </option>
//             ))}
//           </NativeSelect>
//         </Grid.Col>
//         <Grid.Col span={4}>
//           <NativeSelect
//             value={date.month.name}
//             onChange={handleMonthChange}
//             label="ماه"
//             size="md"
//           >
//             {months.map((month) => (
//               <option key={month} value={month}>
//                 {month}
//               </option>
//             ))}
//           </NativeSelect>
//         </Grid.Col>
//         <Grid.Col span={4}>
//           <NativeSelect
//             label="سال"
//             size="md"
//             value={date.year}
//             onChange={handleYearChange}
//           >
//             {years.map((year) => (
//               <option key={year} value={year}>
//                 {year}
//               </option>
//             ))}
//           </NativeSelect>
//         </Grid.Col>
//       </Grid>
//     </Stack>
//   );
// };

interface DateSelectorProps {
  selectedDate: DateObject;
  onChange: (newDate: DateObject) => void;
}

export const DateSelector: React.FC<DateSelectorProps> = ({
  selectedDate,
  onChange,
}) => {
  const today = new DateObject({ calendar: persian, locale: persian_fa });
  const [date, setDate] = useState<DateObject>(
    new DateObject({ ...selectedDate, calendar: persian, locale: persian_fa })
  );
  const [days, setDays] = useState<number[]>([]);
  const [months, setMonths] = useState<string[]>([]);
  const [years] = useState<number[]>(
    Array.from({ length: 3 }, (_, i) => today.year + i)
  );

  useEffect(() => {
    const updateDays = () => {
      const daysInMonth = getDaysInMonth(date);
      const startDay = isSameMonthAndYear(date, today) ? today.day : 1;
      setDays(
        Array.from(
          { length: daysInMonth - startDay + 1 },
          (_, i) => startDay + i
        )
      );
    };

    const updateMonths = () => {
      const availableMonths =
        date.year === today.year
          ? date.locale.months.map((x) => x[0]).slice(today.month.index)
          : date.locale.months.map((x) => x[0]);

      setMonths(availableMonths);
    };

    updateDays();
    updateMonths();
  }, [date?.year, date?.month?.index]);

  const isSameMonthAndYear = (d1: DateObject, d2: DateObject) => {
    return d1.year === d2.year && d1.month.index === d2.month.index;
  };

  const getDaysInMonth = (date: DateObject): number => {
    const daysInMonth: Record<number, number> = {
      1: 31,
      2: 31,
      3: 31,
      4: 31,
      5: 31,
      6: 31,
      7: 30,
      8: 30,
      9: 30,
      10: 30,
      11: 30,
      12: isLeapYear(date.year) ? 30 : 29,
    };
    return daysInMonth[date?.month?.index + 1] || 29;
  };

  const isLeapYear = (year: number): boolean => {
    return year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0);
  };

  const handleDayChange = (e: string) => {
    const day = parseInt(e, 10);
    const newDate = new DateObject(date);
    newDate["day"] = day;
    setDate(newDate);
    onChange(newDate);
  };

  const handleMonthChange = (e: string) => {
    const newDate = new DateObject(date);
    const newMonthIndex = date.locale.months.findIndex((x) => x[0] === e);
    newDate.setMonth(newMonthIndex + 1);
    setDate(newDate);
    onChange(newDate);
  };

  const handleYearChange = (e: string) => {
    const year = parseInt(e, 10);
    const newDate = new DateObject(date);
    newDate["year"] = year;
    setDate(newDate);
    onChange(newDate);
  };

  const style = {
    display: "inline-block",
    width: "90px",
    fontSize: "16px",
    margin: "0 5px",
  };

  return (
    <Group wrap="nowrap">
      <NativeSelect
        value={date?.day?.toString()}
        onChange={(e) => handleDayChange(e.target.value)}
        style={style}
        data={days.map((day) => ({
          label: day.toString(),
          value: day.toString(),
        }))}
      />
      <NativeSelect
        value={date?.month?.name.toString()}
        onChange={(e) => handleMonthChange(e.target.value)}
        style={style}
        data={months.map((month) => ({
          label: month,
          value: month,
        }))}
      />

      <NativeSelect
        value={date?.year?.toString()}
        onChange={(e) => handleYearChange(e.target.value)}
        style={style}
        data={
          years.map((year) => ({
            value: year.toString(),
            label: year.toString(),
          })) || []
        }
      />
    </Group>
  );
};
